import { forwardRef } from 'react'
import { Text as ThemeUIText, TextProps as ThemeUITextProps } from 'theme-ui'

export type TextProps = ThemeUITextProps & {}

export const Text = forwardRef<HTMLDivElement, TextProps>(
  ({ ...rest }, ref) => (
    <ThemeUIText ref={ref as any} {...rest}>
      {rest.children}
    </ThemeUIText>
  )
)
